import { render, staticRenderFns } from "./PatientsFormDocuments.vue?vue&type=template&id=88f883a4&"
import script from "./PatientsFormDocuments.vue?vue&type=script&lang=js&"
export * from "./PatientsFormDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports